/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MedicalPersonLightResponse
 */
export interface MedicalPersonLightResponse {
    /**
     * the unique identifier of medical person
     * @type {string}
     * @memberof MedicalPersonLightResponse
     */
    id?: string;
    /**
     * the firstname and lastname of medical person
     * @type {string}
     * @memberof MedicalPersonLightResponse
     */
    name?: string;
    /**
     * the active status of the medical person
     * @type {boolean}
     * @memberof MedicalPersonLightResponse
     */
    active?: boolean;
    /**
     * the role of the medical person
     * @type {string}
     * @memberof MedicalPersonLightResponse
     */
    role?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MedicalPersonLightResponse
     */
    institutes?: Array<string>;
}

/**
 * Check if a given object implements the MedicalPersonLightResponse interface.
 */
export function instanceOfMedicalPersonLightResponse(value: object): value is MedicalPersonLightResponse {
    return true;
}

export function MedicalPersonLightResponseFromJSON(json: any): MedicalPersonLightResponse {
    return MedicalPersonLightResponseFromJSONTyped(json, false);
}

export function MedicalPersonLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicalPersonLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'] == null ? undefined : json['active'],
        'role': json['role'] == null ? undefined : json['role'],
        'institutes': json['institutes'] == null ? undefined : json['institutes'],
    };
}

export function MedicalPersonLightResponseToJSON(json: any): MedicalPersonLightResponse {
    return MedicalPersonLightResponseToJSONTyped(json, false);
}

export function MedicalPersonLightResponseToJSONTyped(value?: MedicalPersonLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'role': value['role'],
        'institutes': value['institutes'],
    };
}

